<div [formGroup]="form" class="form-col form-col-8">
    <mat-form-field class="mat-block form-input">
       <input matInput [maxlength]="40"
              placeholder="Коментар до адреси (не обов’язково)"
              [formControlName]="controlName"
              autoScrollTarget
              InputTrim>
      <mat-error>{{ getError(addressNoteControl, AddressNoteErrors) }}</mat-error>
    </mat-form-field>
</div>
